import mutationQuery from '../../mutations/system/SystemScreenMutation.graphql';
import fragment from '../../fragments/system/SystemScreenFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SystemFolder: EntityType = {
  type: 'SystemScreen',
  title: 'Screen',
  update: mutationQuery,
  fragment,
  screenReference: 'SYSTEM_SCREEN',
};

export default SystemFolder;
